<template>
  <v-container v-if="currentUser" fluid>
    <v-app-bar app color="secondary" dark dense>
      <v-toolbar-title>
        {{ $t("auditor.home.title", { ...currentUser }) }}
      </v-toolbar-title>
    </v-app-bar>

    <v-row>
      <v-col cols="12">
        <v-card :loading="!auditPeriods">
          <v-card-title>
            {{ $t("auditor.myAuditPeriods") }}

            <v-spacer></v-spacer>

            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              :label="$t('audit.users.search')"
              color="secondary"
              single-line
            ></v-text-field>
          </v-card-title>

          <AuditPeriodTable
            v-if="auditPeriods"
            :year="year"
            :auditPeriods="auditPeriods"
            :search="search"
          ></AuditPeriodTable>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import HomeQuery from "@/gql/queries/HomeQuery.gql";
import AuditPeriodQuery from "@/gql/queries/auditor/AuditPeriodQuery.gql";
import AuditPeriodTable from "@/components/Audit/AuditPeriods/AuditPeriodTableTable.vue";

export default {
  components: {
    AuditPeriodTable,
  },

  data() {
    return {
      currentUser: null,
      auditPeriods: null,
      year: new Date().getFullYear(),
      search: "",
    };
  },

  computed: {},

  apollo: {
    currentUser: {
      query: HomeQuery,
      fetchPolicy: "cache-and-network",
    },

    auditPeriods: {
      query: AuditPeriodQuery,
      fetchPolicy: "cache-and-network",
      skip() {
        return !this.currentUser;
      },
      variables() {
        return {
          year: this.year,
          auditor: this.currentUser.id,
        };
      },
    },
  },
};
</script>
